import React from "react";
import { Route, Switch } from "react-router-dom";

// Routes
import { settingsRoutes } from "../config/routes";
// Sub Pages
import SettingsMenuComponent from "../components/Menus/SettingsMenu";
import {
  AvailabilitySettingsPage,
  GeneralComponent,
  ProfileComponent,
  StatisticsComponent,
} from "../components/Settings";

const SettingsComponent: React.FC = () => (
  <div id="Settings">
    <Switch>
      <Route exact path={settingsRoutes[0]} component={SettingsMenuComponent} />
      <Route exact path={settingsRoutes[1]} component={ProfileComponent} />
      <Route exact path={settingsRoutes[2]} component={AvailabilitySettingsPage} />
      <Route exact path={settingsRoutes[3]} component={StatisticsComponent} />
      <Route exact path={settingsRoutes[4]} component={GeneralComponent} />
    </Switch>
  </div>
);
export default SettingsComponent;
